/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Sync_Amount_ReadonlyInputs */

const vi_expense_sync_amount_readonly = /** @type {(inputs: Expense_Sync_Amount_ReadonlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số tiền và ngày lấy từ giao dịch ngân hàng, không sửa được`)
};

/**

* @param {Expense_Sync_Amount_ReadonlyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_sync_amount_readonly = /** @type {((inputs?: Expense_Sync_Amount_ReadonlyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Sync_Amount_ReadonlyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_sync_amount_readonly(inputs)
});